module.exports = __webpack_public_path__ + "static/media/arrow-forward.75ec618d.svg";